import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';

import { subscriptions } from 'app/selectors/subscriptions';
import { manageSubscription } from 'app/api/subscriptions';
import { fetchSubscriptionsStatus } from 'app/api/subscriptions';
import Subscription from 'app/components/settings/subscription';

const { getStringsForPage } = contentfulModels;

const mapStateToProps = state => ({
  canManageSubscriptions: subscriptions.canManage(state),
  subscriptionManageLink: subscriptions.getManageLink(state),
  subscription: subscriptions.current(state),
  pageStrings: getStringsForPage(_.get(state, 'accountSettings.settingsPage.fields')),
});

const mapDispatchToProps = dispatch => ({
  onManageSubscriptions: (url, onComplete) => dispatch(manageSubscription(url, onComplete)),
});

const SubscriptionContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch }) => Promise.all([
    dispatch(fetchSubscriptionsStatus()),
  ]))(Subscription),
);

export default SubscriptionContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/subscription.js